import React from "react";

import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const TopbarACALogo = () => {
  const acaLogoConfig = useStaticQuery(graphql`
    {
      allMarkdownRemark(
        filter: { frontmatter: { type: { eq: "website_config_common" } } }
      ) {
        edges {
          node {
            frontmatter {
              aca_logo {
                childImageSharp {
                  gatsbyImageData(layout: FIXED)
                }
              }
            }
          }
        }
      }
    }
  `);

  const acaLogo =
    acaLogoConfig.allMarkdownRemark.edges[0].node.frontmatter.aca_logo;
  const acaLogoImg = getImage(acaLogo);
  // TODO env params
  return (
    <div id="topbar-aca-link-to-promo">
      <a href="https://www.aicontentautomation.xyz">
        <GatsbyImage
          image={acaLogoImg}
          alt={"Get AI Content That You Need:"}
          title={"https://promo.aicontentautomation.xyz"}
        />
      </a>
    </div>
  );
};

export { TopbarACALogo };
